module.exports = __webpack_public_path__ + "files/58fc83686953e32bce2b1e8d87438abc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/alpha-horizontal.png
 ** module id = 830
 ** module chunks = 0
 **/